/**
 * NORSAN PRODUCT MANAGER - Komplett Master med Scroll-lås + Rich Text
 * RETTET (2026-09-21): fixNorsanGallery() er deaktiveret, fordi den skjulte
 * det første produktbillede permanent på alle standalone-produkter.
 * TILFØJET (2026-09-22): fixRapiCrossSellThumbs() - workaround for at Rapid
 * Bundle's cross-sell-widget (Beta) ikke selv formår at vise produktbilledet
 * i "tilkøb"-boksen, selvom billedet loader korrekt. Vi maler billedet ind
 * som CSS-baggrund på boksen i stedet for at stole på appens eget <img>-tag.
 */
(function() {

  // --- RICH TEXT PARSER ---
  function norsanParseRichText(node) {
    if (!node) return "";

    switch (node.type) {
      case "root":
        return node.children.map(norsanParseRichText).join("");

      case "paragraph":
        return `<p>${node.children.map(norsanParseRichText).join("")}</p>`;

      case "text":
        return node.value || "";

      case "link":
        return `<a href="${node.url}" target="_blank" rel="noopener">${node.children.map(norsanParseRichText).join("")}</a>`;

      case "list":
        const tag = node.listType === "number" ? "ol" : "ul";
        return `<${tag}>${node.children.map(norsanParseRichText).join("")}</${tag}>`;

      case "list-item":
        return `<li>${node.children.map(norsanParseRichText).join("")}</li>`;

      case "bold":
        return `<strong>${node.children.map(norsanParseRichText).join("")}</strong>`;

      case "italic":
        return `<em>${node.children.map(norsanParseRichText).join("")}</em>`;

      default:
        return node.children ? node.children.map(norsanParseRichText).join("") : "";
    }
  }

  function parseRichOrText(raw) {
    if (!raw || raw === '""' || raw === "") return "";

    // Hvis det er et objekt (Rich Text fra Shopify .value | json)
    if (typeof raw === "object") {
      return norsanParseRichText(raw);
    }

    // Hvis det er en streng, prøv å se om det er JSON-format
    if (typeof raw === "string") {
      // Sjekk om strengen ser ut som JSON før vi prøver å parse
      if (raw.trim().startsWith('{')) {
        try {
          const json = JSON.parse(raw);
          return norsanParseRichText(json);
        } catch (e) {
          return raw; // Fallback til råtekst hvis parsing feiler
        }
      }
      return raw; // Vanlig tekststreng
    }

    return "";
  }

  const TARGET_DIV_ID = 'product-bundles';
  let isUpdating = false;
  let savedScrollY = 0;

  // --- 1. SCROLL-LÅS ---
  const lockScroll = () => {
    savedScrollY = window.scrollY;
    isUpdating = true;

    const forcePos = () => {
      if (isUpdating) window.scrollTo(0, savedScrollY);
    };

    window.addEventListener('scroll', forcePos, { passive: false });

    setTimeout(() => {
      isUpdating = false;
      window.removeEventListener('scroll', forcePos);
    }, 600);
  };

  // --- 2. GALLERI-LOGIKK ---
  // DEAKTIVERET (2026-09-21): Denne funktion skjulte tidligere det første
  // produktbillede/thumbnail som "neutral tilstand", indtil kunden klikkede
  // en variant-swatch (Olie/Kapsler). Det gav mening på den gamle, fælles
  // produktside med varianter - men alle produkter er nu selvstændige uden
  // varianter, så funktionen skal ikke længere ændre nogen visning.
  function fixNorsanGallery() {
    return;
  }

  // --- 3. TVUNGEN NØYTRAL START ---
  function resetNeutralStart() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('variant')) {
      document.querySelectorAll('variant-picker input[type="radio"]').forEach(input => {
        input.checked = false;
        if (input.parentElement) {
          input.parentElement.classList.remove('active');
        }
      });

      const titleEl = document.getElementById('variant-picker-title');
      const textEl = document.getElementById('variant-picker-text');

      if (window.NORSAN_PRODUCT_DATA) {
        if (titleEl) titleEl.textContent = window.NORSAN_PRODUCT_DATA.defaultPickerTitle || '';

        if (textEl) {
          const rawDefault = window.NORSAN_PRODUCT_DATA.defaultPickerText;
          textEl.innerHTML = parseRichOrText(rawDefault);
        }
      }

      fixNorsanGallery();
    }
  }

  // --- 4. LIVE TITTEL- OG TEKST-OPPDATERING ---
  function updateVariantPickerTitle() {
    const titleEl = document.getElementById('variant-picker-title');
    const textEl = document.getElementById('variant-picker-text');
    const data = window.NORSAN_PRODUCT_DATA;
    if (!data) return;

    const activeInput = document.querySelector('variant-picker input[type="radio"]:checked');
    const urlParams = new URLSearchParams(window.location.search);

    // Før valg
    if (!urlParams.has('variant') && !document.body.classList.contains('variant-clicked')) {
      if (titleEl) titleEl.textContent = data.defaultPickerTitle || '';

      if (textEl) {
        const rawDefault = data.defaultPickerText;
        textEl.innerHTML = parseRichOrText(rawDefault);
      }
      return;
    }

    // Etter valg
    if (activeInput) {
      const id = activeInput.getAttribute('data-option-value-id') || activeInput.value;
      const variantByData = data.variantsById?.[id] || data.variants?.[activeInput.value];

      if (variantByData) {
        if (titleEl) titleEl.textContent = variantByData.pickerTitle || data.defaultPickerTitle || '';

        if (textEl) {
          const raw = variantByData.pickerText || data.defaultPickerText || "";
          textEl.innerHTML = parseRichOrText(raw);
        }

      } else {
        if (titleEl) titleEl.textContent = data.defaultPickerTitle || '';

        if (textEl) {
          const rawDefault = data.defaultPickerText;
          textEl.innerHTML = parseRichOrText(rawDefault);
        }
      }
    }
  }


  function runManager() {
    const target = document.getElementById(TARGET_DIV_ID);
    const rapiSource = document.querySelector('.rapi-bundle-content-0');

    if (rapiSource && target && !target.contains(rapiSource)) {
      target.appendChild(rapiSource);
      rapiSource.style.display = 'block';
    }

    if (window.NORSAN_PRODUCT_DATA?.variants) {
      document.querySelectorAll('variant-picker label.label-swatch').forEach(label => {
        if (label.querySelector('.variant-content-wrapper')) return;
        const input = document.getElementById(label.getAttribute('for'));
        const vData = window.NORSAN_PRODUCT_DATA.variants[input?.value];
        if (vData) {
          const iconHtml = vData.icon ? `<img src="${vData.icon}" class="variant-icon">` : '';
          label.innerHTML =
            `<div class="variant-content-wrapper">${iconHtml}<div class="variant-text-container"><div class="variant-main-title">${vData.mainTitle}</div><div class="variant-sub-title">${vData.subTitle}</div></div></div>`;
        }
      });
    }
  }

  // --- 6. FIX FOR RAPID BUNDLE CROSS-SELL THUMBNAIL (billede vises ikke) ---
  // Rapid Bundle's egen React-komponent henter billedet korrekt (vi kan se
  // det som en 200'er i Network-fanen), men får det aldrig vist i selve
  // <img>-taget i cross-sell-boksen. Vi omgår det ved selv at læse src'en
  // fra det (evt. "usynlige") <img>-tag og male den ind som CSS-baggrund på
  // den omkringliggende boks i stedet.
  function fixRapiCrossSellThumbs() {
    document.querySelectorAll('.cross-sell-ui__list-thumb img, .rapi-cross-sell-list__thumb img').forEach(img => {
      if (img.src && !img.dataset.norsanFixed) {
        img.dataset.norsanFixed = 'true';
        const wrapper = img.closest('.cross-sell-ui__list-thumb, .rapi-cross-sell-list__thumb');
        if (wrapper) {
          wrapper.style.backgroundImage = 'url("' + img.src + '")';
          wrapper.style.backgroundSize = 'cover';
          wrapper.style.backgroundPosition = 'center';
        }
      }
    });
  }

  const rapiThumbObserver = new MutationObserver(fixRapiCrossSellThumbs);
  rapiThumbObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(fixRapiCrossSellThumbs, 500);

  // --- 5. EVENTS ---
  document.addEventListener('mousedown', (e) => {
    if (e.target.closest('variant-picker input') || e.target.closest('.label-swatch')) {
      lockScroll();
      document.body.classList.add('variant-clicked');
    }
  }, true);

  document.addEventListener('click', (e) => {
    const label = e.target.closest('.label-swatch');
    if (label) {
      setTimeout(() => {
        updateVariantPickerTitle();
        runManager();
        fixNorsanGallery();
      }, 50);
    }
  }, true);

  const observer = new MutationObserver(() => {
    runManager();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // INITIALISERING
  setTimeout(() => {
    resetNeutralStart();
    runManager();
    updateVariantPickerTitle();
  }, 15);

  document.addEventListener('variant:changed', () => {
    updateVariantPickerTitle();
    fixNorsanGallery();
  });

})();